import React, { useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";

export default function DF_OT0052({ rowData, onCancelSuccess, onClose }) {
  console.log("🤖 %cTransação [DF_OT0052] ", "color:red");

  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      
      setShowSuccess(true);
    } catch (error) {
      console.error("Erro ao cancelar o local de entrega", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseAll = () => {
    setShowSuccess(false);
    if (onCancelSuccess) onCancelSuccess();
  };

  if (showSuccess) {
    return (
      <Modal isOpen={true} toggle={handleCloseAll} centered className="modal-custom-style rounded">
        <ModalBody className="text-center p-5">
          <div className="mb-4 d-flex align-items-center justify-content-center">
            <div 
              className="d-flex align-items-center justify-content-center"
              style={{ width: "110px", height: "110px", backgroundColor: "#4caf50", borderRadius: "50%" }}
            >
              <i className="fas fa-check text-white" style={{ fontSize: "55px" }}></i>
            </div>
          </div>
          <h2 className="font-w-600 text-color-azul1 mb-2" style={{ fontSize: "32px" }}>Sucesso!</h2>
          <p className="text-muted font-size-16 mb-4">O Local de Entrega foi removido com sucesso!</p>
          <Button 
            onClick={handleCloseAll} 
            style={{ backgroundColor: "#2b3b6b", minWidth: "120px", height: "45px" }} 
            className="border-0 font-w-600 text-white rounded font-size-16"
          >
            Ok!
          </Button>
        </ModalBody>
      </Modal>
    );
  }

  return (
    <Modal isOpen={true} toggle={onClose} centered className="modal-custom-style rounded">
      <ModalBody className="text-center p-5">
        <div className="mb-4 d-flex align-items-center justify-content-center">
          <div 
            className="d-flex align-items-center justify-content-center"
            style={{ width: "110px", height: "110px", backgroundColor: "#ffb300", borderRadius: "50%" }}
          >
            <i className="fas fa-exclamation-triangle text-white" style={{ fontSize: "50px" }}></i>
          </div>
        </div>
        <h3 className="font-w-600 text-color-azul1 mb-3" style={{ fontSize: "26px" }}>
          Deseja cancelar este Local de Entrega?
        </h3>
        <p className="text-muted font-size-15 mb-4 px-3">
          Ao clicar em “Confirmar”, o Local de Entrega selecionado será removido.
          {rowData?.ID && <span className="d-block font-w-600 mt-1">ID selecionado: {rowData.ID}</span>}
        </p>
        <div className="d-flex justify-content-center gap-3">
          <Button 
            onClick={onClose} 
            color="light" 
            className="font-w-600 text-color-azul1 border bg-white rounded"
            style={{ height: "42px", minWidth: "120px" }}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button 
            onClick={handleConfirmDelete} 
            className="border-0 font-w-600 text-white rounded"
            style={{ backgroundColor: "#2b3b6b", height: "42px", minWidth: "120px" }}
            disabled={loading}
          >
            {loading ? "Aguardando..." : "Confirmar"}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}